export default "/images/0dc2cea9f06109750c009e88bd4e417e.png";